import React from "react";
import { FiPhoneCall } from "react-icons/fi";
import { TfiEmail } from "react-icons/tfi";
import { GrLocation } from "react-icons/gr";

const contactItems = [
  {
    icon: (
      <GrLocation
        size={44}
        className="text-[#E36208] text-2xl border-b-2 border-[#E36208] mt-8 mb-6"
      />
    ),
    text: "Near Reliance Fresh, Satya Vihar, Rasulgarh, BBSR - 751010",
  },
  {
    icon: <TfiEmail size={44} className="text-orange-500 text-2xl mt-8 mb-6" />,
    text: "manikainfo@gmail.com",
  },
  {
    icon: (
      <FiPhoneCall size={44} className="text-orange-500 text-2xl mt-8 mb-6" />
    ),
    text: "7017774127, 7656934714",
  },
];

const ContactInfo = () => {
  return (
    <div className="bg-[#fff] px-4 md:px-10 py-10">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {contactItems.map((item, index) => (
          <div
            key={index}
            className="p-6 mb-6 flex flex-col items-center text-center rounded shadow-md hover:shadow-xl transition bg-[#F5F6FA]"
          >
            {item.icon}
            <p className="text-[#182630] font-quicksand font-medium text-base leading-[1.7] tracking-[0.5%] text-center md:w-2/3 mb-8">
              {item.text}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContactInfo;
